<template lang="pug">
.idea-box.column(v-if="data" :id="data.id" @drop="drop($event, data.id)" @dragover.prevent @dragenter.prevent :class="{ archived: data.archived, opened: filter_opened }")
  .archived-indicator(v-if="data.archived") {{ t.archived }}
  .box-title.row.between.center.top
    .row.center.flex-1
      input(v-if="edit" :placeholder="t.title" v-model="data.title" @change="$root.save_box(data)" @keyup.enter="$nextTick(() => edit = false)")
      div.flex-1(v-else) {{ data.title }}
    .row.center
      button.icon.edit.circle(@click="edit = !edit;log('qds')")
        fa-icon(:icon="edit ? 'save' : 'pen'" size="18px" v-if="$root.permissions.includes('manage')")
      button.green.circle.add-post.icon.row.center(@click="$root.modal = { name: 'new_idea', box_id: data.id}")
        font-awesome-icon(icon="plus")
  .column(v-if="edit" style="margin-bottom: 8px;")
    div {{ t.linked_calendar }}
    select(@change="$root.link_calendar(data.id, $event.target.value)")
      option(v-for="account, account_id in $root.accounts.filter(v => !v.disabled)" :value="account_id" :selected="data.linked_calendar === account_id") {{ account.name }}
  .row.center.between.filters
    vue-dropdown(:data="statuses" v-model="filters" @opened="filter_opened = $event")
      .row
        fa-icon(icon="chevron-down" size="12px")
        div {{ t.filters }}
    .row.center
      .row.center(@click="cycle_order")
        div {{t.order}}: {{ t[order] || order }}
        fa-icon(:icon="order_desc ? 'caret-down' : 'caret-up'" size="16px")
      .archive.icon(v-if="$root.permissions.includes('archive')" @click="$root.archive_box(data.id, !data.archived)")
        svg-icon(name="archive")
  idea-card(v-for="idea in sorted_ideas" :data="idea" :calendar_id="data.linked_calendar" draggable @dragstart="drag($event, idea.id)" :id="idea.id" :key="idea.id" @click="$root.modal = { name: 'idea', data: idea, calendar_id: data.linked_calendar }")
</template>
<script>
export default {
  props: ['data'],
  data() {
    return {
      edit: false,
      filters: ['submitted', 'confirmed', 'scheduled'],
      statuses: ['submitted', 'confirmed', 'scheduled', 'denied', 'published'],
      order: 'date_created',
      order_desc: true,
      orders: ['date_created', 'publication_date'],
      filter_opened: false,
    }
  },
  computed: {
    filtered_ideas() {
      if (!this.data || !this.data.ideas) return
      if (this.$root.search) {
        const search = new RegExp(this.$root.search, 'i')
        return this.data.ideas.filter(d => search.test(d.title) || search.test(d.description))
      }
      return this.data.ideas.filter(d => this.filters.includes(d.status))
    },
    sorted_ideas() {
      if (!this.filtered_ideas) return
      return this.filtered_ideas.vls().sortBy(this.order, this.order_desc)
    }
  },
  methods: {
    drag(ev, idea_id) {
      console.log(ev, idea_id)
      ev.dataTransfer.setData('idea_id', idea_id)
    },
    drop(ev, box_id) {
      // ev.preventDefault()
      const idea_id = ev.dataTransfer.getData('idea_id')
      this.$root.change_box(idea_id, box_id)
    },
    cycle_order() {
      if (this.order_desc) return this.order_desc = false
      this.order_desc = true
      const index = this.orders.indexOf(this.order)
      if (index >= this.orders.length - 1) return this.order = this.orders[0]
      this.order = this.orders[index +1]
    }
  },
  watch: {
  }
}
</script>
<style>
.idea-box {
  background: rgba(255,255,255,0.6);
  border-radius: var(--box-radius);
  padding: 16px;
  max-height: calc(calc(var(--full-height) - var(--nav-top-height)) - 16px);
  overflow-y: auto;
  height: fit-content;
  position: relative;
}
.idea-box.opened {
  overflow: visible;
}
.idea-box.archived {
  padding-top: 32px;
}
.idea-box .archived-indicator {
  position: absolute;
  top: 0;
  left: 0;
  padding: 2px 16px;
  background: rgba(0,0,0,0.2);
  color: white;
  font-weight: bold;
  width: 100%;
}
.idea-box .box-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 8px;
  min-height: 40px;
}
.idea-box .box-title input {
  padding: 8px;
  background: white;
  font: inherit;
  min-width: 0;
  width: 100%;
}
.idea-box .edit {
  margin-left: 8px;
  margin-right: 16px;
}
.idea-box button.add-post {
  height: 32px;
  width: 32px;
  min-width: 32px;
  padding: 6px;
  color: white;
}
.idea-box .filters {
  margin-bottom: 16px;
  font-weight: bold;
  user-select: none;
  cursor: pointer;
}
.idea-box .filters .vue-dropdown .option {
  font-weight: normal;
}
.idea-box .filters .fa-icon {
  margin-right: 4px;
}
.idea-box .archive.icon {
  width: 32px;
  height: 32px;
  padding: 4px;
  cursor: pointer;
  border-radius: 50%;
}
.idea-box .idea-card {
  margin-bottom: 16px;
}


</style>
